import { pauseAllPreviews } from './previewPauseBus';

/**
 * 在新标签页打开视频播放页（/play/video/:id）
 * @param {{ id: number, fileName?: string }} video
 * @returns {Window | null}
 */
export function openVideoPlayWindow(video) {
    if (!video?.id) return null;
    pauseAllPreviews();
    const title = encodeURIComponent(video.fileName || '');
    const url = `${window.location.origin}/play/video/${video.id}?title=${title}`;
    // 使用 _blank 打开新标签页；勿加 noopener，播放页需通过 opener 同步 sessionStorage 登录态
    return window.open(url, '_blank');
}
